export default __webpack_public_path__ + "static/media/hair-soft-autumn.53bf5867.png";